import React, { useEffect } from 'react';
import '../EvaluacionMonitoreo/evaluacionMonitoreo.css';


  const DetalleEvaluacionMonitoreo2026 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Evaluación y Monitoreo a Programas 2026</h2>
            <hr className='hr-gob'/>
          </div>

          <div>
             <table className="table table-striped table-bordered">
                <thead>
                      <tr>
                        <th scope="col" colspan="2"><div className="titulo-programa2026">Programa</div></th>
                        <th scope="col"><div className="titulo-columna">Matriz de Indicadores de Resultados (MIR)</div></th>
                        <th scope="col"><div className="titulo-columna"><p>Ficha Técnica de Indicadores</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Reglas de Operación Federal</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Reglas de Operación Estatal</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Reglamento Interno</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Evaluación realizadas</p></div></th>
                        <th scope="col"><div className="titulo-columna"><p>Seguimientos</p></div></th>
                        <th scope="col"><div className="titulo-columna">Plan de Trabajo a los ASM</div></th>
                        <th scope="col"><div className="titulo-columna"><p>Seguimiento a los ASM</p></div></th>
                      </tr>
                    </thead>
              </table>
          </div>
          <div className="contenedor-tabla">
           <table className="table table-striped table-bordered">
                    <tbody>
                      <tr>
                        <th scope="row" colspan="11"><div className="th-seccion">Alimentación para el Pueblo</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                       <th scope="row"><div className="div-programa2026">Atención Alimentaria a Personas en Situación de Vulnerabilidad, Personas Mayores</div></th>  
                        <td>
                            <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2025_ATN_ALIM_ADULTOS_MAYORES_0001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                            </div> 
                        </td>
                        <td>
                            <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_ALIMENTARIA_A_PERSONAS_EN_SITUACION_DE_VULNERABILIDAD_PERSONAS_MAYORES.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_VULNERABILIDAD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td><div className="div-td"></div></td>
                        <td><div className="div-td"></div></td>
                        <td></td>
                        <td><div className="div-td"></div></td>
                        <td></td>
                        <td><div className="div-td"></div></td>
                      </tr> 

                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                       <th scope="row"><div className="div-programa2026">Atención Alimentaria a Personas en Situación de Vulnerabilidad, Personas con Discapacidad</div></th>  
                        <td>
                            <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_ALIMENTARIA_A_PERSONAS_EN_SITUACION_DE_VULNERABILIDAD_PERSONAS_DISCAPACIDAD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div> 
                        </td>
                        <td>
                            <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_ALIMENTARIA_A_PERSONAS_EN_SITUACION_DE_VULNERABILIDAD_PERSONAS_DISCAPACIDAD.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_VULNERABILIDAD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td><div className="div-td"></div></td>
                        <td><div className="div-td"></div></td>
                        <td></td>
                        <td><div className="div-td"></div></td>
                        <td></td>
                        <td><div className="div-td"></div></td>
                      </tr> 

                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                       <th scope="row"><div className="div-programa2026">Atención Alimentaria a Personas en Situación de Vulnerabilidad, Niñas y Niños de 2 a 5 años de Edad</div></th>  
                        <td>
                            <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_ALIMENTARIA_A_PERSONAS_EN_SITUACION_DE_VULNERABILIDAD_NN_2_5_AÑOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div> 
                        </td>
                        <td>
                            <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_ALIMENTARIA_A_PERSONAS_EN_SITUACION_DE_VULNERABILIDAD_NN_2_5_AÑOS.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                        </td>
                        <td>
                        {/*}  <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_VULNERABILIDAD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>   */}
                        </td>
                        <td><div className="div-td"></div></td>
                        <td><div className="div-td"></div></td>
                        <td></td>
                        <td><div className="div-td"></div></td>
                        <td></td>
                        <td><div className="div-td"></div></td>
                      </tr> 
        
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Atención Alimentaria a Personas en Situación de Emergencia o Desastre</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_ALIMENTARIA_A_PERSONAS_EN_SITUACION_DE_EMERGENCIA_O_DESASTRE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_ALIMENTARIA_A_PERSONAS_EN_SITUACION_DE_EMERGENCIA_O_DESASTRE.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_EMERGENCIA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Atención Alimentaria en los Primeros 1000 días y Primera Infancia</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_ALIMENTARIA_EN_LOS_PRIMEROS_1000_DIAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_ALIMENTARIA_EN_LOS_PRIMEROS_1000_DIAS.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_1000_DIAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>  
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Alimentación Escolar Modalidad Caliente</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ALIMENTACION_ESCOLAR_MODALIDAD_CALIENTE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ALIMENTACION_ESCOLAR_MODALIDAD_CALIENTE.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_FRIO_CALIENTE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Alimentación Escolar Modalidad Frío</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ALIMENTACION_ESCOLAR_MODALIDAD_FRIA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ALIMENTACION_ESCOLAR_MODALIDAD_FRIA.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_FRIO_CALIENTE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Espacios de Alimentación, Encuentro y Desarrollo</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ESPACIOS_ALIMENTARIOS_ENCUENTRO_Y_DESARROLLO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ESPACIOS_ALIMENTARIOS_ENCUENTRO_Y_DESARROLLO.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_EAEyD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Programa Equipamiento y Rehabilitación de Comedores Escolares y/o Comedores Comunitarios</div></th>
                        <td>
                           <div className="div-td">
                          {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_PROTECCION_DE_LOS_DERECHOS_DE_NIÑAS_NIÑOS_Y_ADOLESCENTES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2025_PROTECCION_DERECHOS_NNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PRIORITARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      
                        <tr>
                        <th scope="row" colspan="11"><div className="th-seccion">Formación para Todas y Todos</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa de la Mujer Hidalguense</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_DE_LA_MUJER.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_DE_LA_MUJER_HIDALGUENSE.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                      </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centros de Atención Infantil (CAI)</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CAI.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Atención Infantil Burócratas</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CAI_BUROCRATAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CAI_BUROCRATAS.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                          {/*    <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/R.O.CAI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                 
                      <tr>
                        <th scope="row" colspan="11"><div className="th-seccion">La Salud es Primero</div></th>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Atención Médica y Hospitalaria Pediátrica en Hospital del Niño DIF</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_HOSPITALARIA_PEDIATRICA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_HOSPITALARIA_PEDIATRICA.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_HNDIFH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                          {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/2025_EI_HND.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                          {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/PT_HNDIF.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                           </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Atención Psicológica</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_PSICOLOGICA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_PSICOLOGICA.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_Atencion_Psicologica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Apoyo y Bienestar</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_APOYO_Y_BIENESTAR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_APOYO_Y_BIENESTAR.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PRIORITARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Rehabilitación Integral Hidalgo (CRIH)</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CRIH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CRIH.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PRIORITARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CRIH_VI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Rehabilitación Integral Regional Huehuetla</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CRIR_HUEHUETLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CRIR_Hueheutla.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CRIH_VI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Rehabilitación Integral Regional Huejutla de Reyes</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CRIR_HUEJUTLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CRIR_Huejutla.pdf" target="_blank" rel="noopener noreferrer">
                           <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CRIH_VI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Rehabilitación Integral Regional Ixmiquilpan</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CRIR_IXMIQUILPAN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CRIR_Ixmiquilpan.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CRIH_VI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Rehabilitación Integral Regional Santiago Tulantepec</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CRIR_SANTIAGO_TULANTEPEC.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CRIR_Santiago.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CRIH_VI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Rehabilitación Integral Regional Tula</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CRIR_TULA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                            <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CRIR_Tula.pdf" target="_blank" rel="noopener noreferrer">
                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CRIH_VI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Centro de Rehabilitación Integral Regional Zacualtipan</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CRIR_ZACUALTIPAN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CRIR_Zacualtipan.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_CRIH_VI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Jornadas Médicas de Subespecialidad</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_JORNADAS_MEDICAS_DE_SUBESPECIALIDAD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_JORNADAS_MEDICAS_DE_SUBESPECIALIDAD.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_Jornadas_Medicas_de_Subespecialidad.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Convenio de Colaboración con la Fundación Michou y Mau</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CONVENIO_DE_COLABORACION_FUNDACION_MICHOU_MAU.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CONVENIO_FUNDACION_MICHOU_MAU.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/R.O.JornadasMedicas.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th scope="row" colspan="11"><div className="th-seccion">Cercanía con Grupos Prioritarios</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Atención a Personas en Condiciones de Emergencia</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_A_POB_EN_CONDICIONES_DE_EMERGENCIA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_A_POB_EN_CONDICIONES_DE_EMERGENCIA.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Promoción y Envejecimiento Saludable</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ENVEJECIMIENTO_SALUDABLE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ENVEJECIMIENTO_SALUDABLE.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
      
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Programa de Salud y Bienestar Comunitario</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_PROGRAMA_DE_SALUD_Y_BIENESTAR_COMUNITARIO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_PROGRAMA_DE_SALUD_Y_BIENESTAR_COMUNITARIO.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_SALUD_Y_BIENESTAR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Albergue del Hospital del Niño DIF</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ALBERGUE_PARA_EL_HOSPITAL_DEL_NIÑO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ALBERGUE_PARA_EL_HOSPITAL_DEL_NIÑO.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_Albergue_Hospital_del_Niño_DIF.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Albergue Revolución</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ALBERGUE_REVOLUCION.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ALBERGUE_REVOLUCION.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Ayudas Técnicas</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_AYUDAS_TECNICAS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_Ayudas_Tecnicas.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PRIORITARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa Cuna</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_CUNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_CUNA.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa de Día María Elena Ramirez</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_DE _DIA_MERL.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_DE_DIA_MERL.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa de la Niña</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_DE_LA_NIÑA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_DE_LA_NIÑA.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa de la Adolescente y Transición</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_DE_LA_ADOLESCENTE_Y_DE_TRANSICION.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_DE_LA_ADOLESCENTE_Y_DE_TRANSICION.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa de Día Centro de Expresión para Personas Mayores</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_DE_DIA_CEPM.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_DE_DIA_CEPM.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                      </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa de Día Centro de Expresión para Personas Mayores Usuarios</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_DE_DIA_CEPM_USUARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_DE_DIA_CEPM_USUARIOS.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                      </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Casa del Niño</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_CASA_DEL_NIÑO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_CASA_DEL_NIÑO.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                         </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                   
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Desarrollo de Habilidades en PILARES</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_DESARROLLO_DE_HABILIDADES_EN_PILARES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_DESARROLLO_DE_HABILIDADES_EN_PILARES.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PILARES_PILARESM_DHNNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">PILARES DIF Hidalgo</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_PILARES_DIF_HIDALGO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_PILARES_DIF_HIDALGO.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PILARES_PILARESM_DHNNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">DIF Hidalgo PILARES Morelos</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_DIFH_PILARES_MORELOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_DIFH_PILARES_MORELOS.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PILARES_PILARESM_DHNNA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">DIF Contigo</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_DIF_CONTIGO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                            <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_DIF_Contigo.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_DIF_CONTIGO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes PACHUCA</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_DE_NNA_MIGRANTES_PACHUCA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_DE_NNA_MIGRANTES_PACHUCA.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes HUEJUTLA</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_DE_NNA_MIGRANTES_HUEJUTLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_DE_NNA_MIGRANTES_HUEJUTLA.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                         </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes CIUDAD SAHAGUN</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_DE_NNA_MIGRANTES_SAHAGUN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_DE_NNA_MIGRANTES_SAHAGUN.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Fortalecimiento para la Atención de Niñas, Niños y Adolescentes Migrantes TEPEJI DEL RIO</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_ATENCION_DE_NNA_MIGRANTES_TEPEJI.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_ATENCION_DE_NNA_MIGRANTES_TEPEJI.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Hacia una Vida Mejor</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_HACIA_UNA_VIDA_MEJOR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_Hacia_una_Vida_Mejor.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PRIORITARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">La Casita</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_LA_CASITA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_LA_CASITA.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_AAGPPD_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                           </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Protección de los Derechos de Niñas, Niños y Adolescentes</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_PROTECCION_DE_LOS_DERECHOS_DE_NIÑAS_NIÑOS_Y_ADOLESCENTES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_PROTECCION_DE_LOS_DERECHOS_DE_NIÑAS_NIÑOS_Y_ADOLESCENTES.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PRIORITARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                           {/*   <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/R.O.GruposPrioritarios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                      <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-programa2026">Taller de Órtesis y Prótesis</div></th>
                        <td>
                           <div className="div-td">
                             <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/MIR_2026_TALLER_DE_ORTESIS_Y_PROTESIS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                           </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/FICHAS_2026_Taller_de_Ortesis_y_Protesis.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_PRIORITARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div className="div-td">
                              <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/ROP_TALLER_DE_ORTESIS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                    </tbody>
              </table>  
            </div>  

            <hr />
            <br /><br />  

            <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                <tbody>
                  <tr>
                      <td colspan="3"><p>PROGRAMA ANUAL DE EVALUACIÓN 2026</p></td>
                  </tr>
                  <tr>
                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                    <td style={{ textAlign: "left" }}>Programa Anual de Evaluación 2026</td>
                    <td>
                      <div>
                          <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/PAE_2026.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                      </div>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="3"><p>TÉRMINOS DE REFERENCIA 2026</p></td>
                  </tr>
                  <tr>
                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                    <td style={{ textAlign: "left" }}>TDR - Evaluación de Diseño con Trabajo de Campo</td>
                    <td>
                      <div>
                          <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/TdR_EDTC_2026-DIFH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                    <td style={{ textAlign: "left" }}>TDR - Evaluación de Indicadores</td>
                    <td>
                      <div>
                          <a href="http://dif.hidalgo.gob.mx/pdf/EvaluacionMonitoreo/2026/TdR_Evaluacion_de_Indicadores_DIFH_2026.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                      </div>
                    </td>
                  </tr>
                 </tbody>
              </table> 

              <hr />
              <br /><br />


        </div>
      </div>
    )
}

export default DetalleEvaluacionMonitoreo2026